import { AppInfoFactory } from '../../../shared/factory/app-info/app-info.factory';
import { NotificationUtil } from '../../../shared/util/notification.util';
import { AuthenticationService } from '../../authentication/services/authentication.service';
import { ApplicationConfigService } from './application-config.service';

export const loadAppInfo = async () => {
    // Carrega o perfil do usuário caso não esteja previamente carregado
    if (AuthenticationService.isAuthenticated && !ApplicationConfigService.getLoaded()) {
        try {
            const appInfo = await AppInfoFactory.getAppInfo();
            ApplicationConfigService.setUrlMarketplace(appInfo.marketplaceUrl);
            ApplicationConfigService.setUrlGpassAdmin(appInfo.gpassAdminUrl);
            ApplicationConfigService.sethasFitBankAccount(appInfo.hasFitBankAccount);
            ApplicationConfigService.setLoaded(true);
        } catch (e) {
            if (e) {
                if (e.message) {
                    NotificationUtil.error(e.message);
                } else {
                    NotificationUtil.error(e);
                }
            }
            // AuthenticationService.logout();
        }
    }
};
